import React, { useState } from 'react';

const OfficeCreateForm = ({ onCreateOffice, userAreaSigla }) => {
    const [name, setName] = useState('');
    const [justification, setJustification] = useState('');
    const [originalFile, setOriginalFile] = useState(null);
    const [folio, setFolio] = useState(''); 
    const [showFolio, setShowFolio] = useState(false);

    const handleFileChange = (event) => {
        setOriginalFile(event.target.files[0]);
    };

    const handleSave = async (event) => {
        event.preventDefault(); 

        setFolio('');
        setShowFolio(false);

        if (!name || !justification || !originalFile) {
            alert('Todos los campos de texto son requeridos y el archivo original debe ser subido.');
            return;
        }

        if (!userAreaSigla) {
            alert('Tu usuario no tiene una sigla de área asignada. No se puede crear el oficio.');
            return;
        }

        const officeData = {
            name,
            justification,
            areaSigla: userAreaSigla, 
        };

        try {
            const result = await onCreateOffice(officeData, originalFile);
            
            if (typeof result === 'string' && result) { 
                setFolio(result);
                setShowFolio(true);
            } else {
                alert('No se pudo obtener el folio. Por favor, revisa la consola para más detalles.');
                setShowFolio(false); 
            }

            setName('');
            setJustification('');
            setOriginalFile(null); 
        } catch (error) {
            alert('Error al crear oficio: ' + error.message);
            setShowFolio(false); 
        }
    };

    return (
        <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-2xl font-bold mb-4">Crear Nuevo Oficio</h2>
            <form onSubmit={handleSave}>
                <div className="mb-4">
                    <label htmlFor="name" className="block text-gray-700 text-sm font-bold mb-2">
                        Nombre del Oficio:
                    </label>
                    <input
                        type="text"
                        id="name"
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="justification" className="block text-gray-700 text-sm font-bold mb-2">
                        Justificación:
                    </label>
                    <textarea
                        id="justification"
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline h-32"
                        value={justification}
                        onChange={(e) => setJustification(e.target.value)}
                        required
                    ></textarea>
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2">
                        Tu Sigla de Área:
                    </label>
                    <p className="py-2 px-3 text-gray-700 bg-gray-200 rounded-md">
                        {userAreaSigla || 'No asignada'}
                    </p>
                </div>

                <div className="mb-4">
                    <label htmlFor="originalFile" className="block text-gray-700 text-sm font-bold mb-2">
                        Archivo Original (PDF):
                    </label>
                    <input
                        type="file"
                        id="originalFile"
                        accept=".pdf"
                        onChange={handleFileChange}
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        required
                    />
                </div>
                <div className="flex items-center justify-between">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                    >
                        Generar Oficio
                    </button>
                </div>
            </form>

            {showFolio && (
                <div className="mt-4 p-4 bg-green-100 border border-green-400 text-green-700 rounded">
                    Oficio creado con folio: {folio}
                </div>
            )}
        </div>
    );
};

export default OfficeCreateForm;
